export enum InventorySupportedActions {
  AddOwner = 'addOwner',
  RemoveOwner = 'RemoveOwner',
  SetAccess = 'setAccess',
  ListAccess = 'listAccess',
  Delete = 'delete',
  SendEmail = 'sendEmail',
  Quarantine = 'quarantine',
  Unquarantine = 'unquarantine',
  Stop = 'stop',
  Start = 'start',
  GetResourceDefinition = 'getResourceDefinition',
  GetRawResource = 'getRawResource',
  GetResourceSbomFile = 'getResourceSbomFile',
  PowerplatformSetCopilotAuthentication = 'powerplatformSetCopilotAuthentication',
  PowerplatformGetRawFlowRuns = 'powerplatformGetRawFlowRuns',
  PowerplatformAgentDeleteAction = 'powerplatformAgentDeleteAction',
  PowerplatformAgentActionDeleteAction = 'powerplatformAgentActionDeleteAction',
  PowerplatformAgentActionEnableAction = 'powerplatformAgentActionEnableAction',
  PowerplatformAgentActionDisableAction = 'powerplatformAgentActionDisableAction',
  PowerplatformAgentActionEnforceUserAuthenticationAction = 'powerplatformAgentActionEnforceUserAuthenticationAction',
  PowerplatformAgentActionEnforceUserConfirmationAction = 'powerplatformAgentActionEnforceUserConfirmationAction',
  PowerplatformAgentActionSetAuthenticationModeAction = 'powerplatformAgentActionSetAuthenticationModeAction',
  PowerplatformAgentActionMakerAuthenticationMode = 'powerplatformAgentActionMakerAuthenticationMode',
  PowerplatformAgentActionInvokerAuthenticationMode = 'powerplatformAgentActionInvokerAuthenticationMode',
  PowerplatformAgentActionSetConfirmationModeAction = 'powerplatformAgentActionSetConfirmationModeAction',
  PowerplatformAgentActionStrictConfirmationMode = 'powerplatformAgentActionStrictConfirmationMode',
  PowerplatformAgentActionDisabledConfirmationMode = 'powerplatformAgentActionDisabledConfirmationMode',
  PowerplatformAgentEnableWebBrowsingAction = 'powerplatformAgentEnableWebBrowsingAction',
  PowerplatformAgentDisableWebBrowsingAction = 'powerplatformAgentDisableWebBrowsingAction',
  ChatGptEnterpriseDeleteGptAction = 'chatGptEnterpriseDeleteGptAction',
  ChatGptEnterpriseIsolateGptAction = 'chatGptEnterpriseIsolateGptAction',
  ChatGptEnterpriseDeleteGptKnowledgeAction = 'chatGptEnterpriseDeleteGptKnowledgeAction',
  ChatGptEnterpriseGetGptKnowledgeFileUrlAction = 'ChatGptEnterpriseGetGptKnowledgeFileUrlAction',
  ChatGptEnterpriseDeleteUserCanvasAction = 'chatGptEnterpriseDeleteUserCanvasAction',
  ChatGptEnterpriseGetUserCanvasAction = 'chatGptEnterpriseGetUserCanvasAction',
}
